export const getSpacing = (x: number) => x * 4;

export const spacing = {
  0: `${getSpacing(0)}px` as "0px",
  0.5: `${getSpacing(0.5)}px` as "2px",
  1: `${getSpacing(1)}px` as "4px",
  1.5: `${getSpacing(1.5)}px` as "6px",
  2: `${getSpacing(2)}px` as "8px",
  2.5: `${getSpacing(2.5)}px` as "10px",
  3: `${getSpacing(3)}px` as "12px",
  4: `${getSpacing(4)}px` as "16px",
  5: `${getSpacing(5)}px` as "20px",
  6: `${getSpacing(6)}px` as "24px",
  7: `${getSpacing(7)}px` as "28px",
  8: `${getSpacing(8)}px` as "32px",
  9: `${getSpacing(9)}px` as "36px",
  10: `${getSpacing(10)}px` as "40px",
  12: `${getSpacing(12)}px` as "48px",
  14: `${getSpacing(14)}px` as "56px",
  16: `${getSpacing(16)}px` as "64px",
  20: `${getSpacing(20)}px` as "80px",
  24: `${getSpacing(24)}px` as "96px",
};
